import { createGlobalStyle } from 'styled-components'

import Interface  from './InterFace.woff'
import InterfaceItalic  from './InterFace-Italic.woff'
import InterfaceItalic2  from './InterFace-Italic.woff2'
import InterfaceThiItalic  from './InterFaceThin-Italic.woff'
import InterfaceThinItalic2  from './InterFaceThin-Italic.woff2'
import InterfaceThin  from './InterFaceThin.woff'
import InterfaceXBoldItalic  from './InterFaceXBold-Italic.woff'
import InterfaceXBoldItalic2  from './InterFaceXBold-Italic.woff2'
import InterfaceXBold  from './InterFaceXBold.woff'
import InterfaceXBold2  from './InterFaceXBold.woff2'


export default createGlobalStyle`
  @font-face {
    font-family: 'Interface';
    src: url(${Interface}) format('woff2'),
         url(${Interface}) format('woff2');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Interface';
    src: url(${InterfaceItalic}) format('woff'),
         url(${InterfaceItalic}) format('woff');
    font-weight: 400;
    font-style: italic;
  }

  @font-face {
    font-family: 'Interface';
    src: url(${InterfaceItalic2}) format('woff2'),
         url(${InterfaceItalic2}) format('woff2');
    font-weight: 400;
    font-style: italic;
  }

  @font-face {
    font-family: 'Interface';
    src: url(${InterfaceThiItalic}) format('woff'),
         url(${InterfaceThiItalic}) format('woff');
    font-weight: 300;
    font-style: italic;
  }

  @font-face {
    font-family: 'Interface';
    src: url(${InterfaceThinItalic2}) format('woff2'),
         url(${InterfaceThinItalic2}) format('woff2');
    font-weight: 300;
    font-style: italic;
  }

  @font-face {
    font-family: 'Interface';
    src: url(${InterfaceThin}) format('woff'),
         url(${InterfaceThin}) format('woff');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Interface';
    src: url(${InterfaceXBold}) format('woff'),
         url(${InterfaceXBold}) format('woff');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Interface';
    src: url(${InterfaceXBold2}) format('woff2'),
         url(${InterfaceXBold2}) format('woff2');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Interface';
    src: url(${InterfaceXBoldItalic}) format('woff'),
         url(${InterfaceXBoldItalic}) format('woff');
    font-weight: bold;
    font-style: italic;
  }

  @font-face {
    font-family: 'Interface';
    src: url(${InterfaceXBoldItalic2}) format('woff2'),
         url(${InterfaceXBoldItalic2}) format('woff2');
    font-weight: bold;
    font-style: italic;
  }


`